import React from 'react'

import { Dashboard } from '@components/common'
import { Skeleton } from '@fourthwall/components'
import { StatGroup } from '@fourthwall/module-analytics'

export const AnalyticsSkeleton = () => (
  <div>
    <div style={{ marginBottom: 24 }}>
      <Skeleton.Shape height={36} width={260} />
    </div>
    <Dashboard.Section.ScrollableContent hideScrollbar fullWidth>
      <StatGroup>
        <Skeleton.Shape height={172} width="100%" />
        <Skeleton.Shape height={172} width="100%" />
        <Skeleton.Shape height={172} width="100%" />
      </StatGroup>
    </Dashboard.Section.ScrollableContent>
  </div>
)
